// The `data-testid` values the site actually renders. Keep this list to ids that
// exist in the DOM: an entry for a section that was never built reads as a
// promise the markup does not keep, and the previous version of this file was
// half full of them — `instagram`, `marquee`, `process` — sections the Figma cut.
export const TID = {
    navbar: "navbar",
    navbarLogo: "navbar-logo",
    navbarInstagram: "navbar-instagram",
    navbarMenu: "navbar-menu",
    navbarCta: "navbar-cta",

    floatingCta: "floating-cta",
};
